import { useTheme } from '@/context/ThemeContext';

export interface ChartTheme {
  isDark: boolean;
  grid: string;
  axis: string;
  surface: string;
  border: string;
  series: string[];
  duo: { returning: string; new: string };
}

const LIGHT: Omit<ChartTheme, 'isDark'> = {
  grid: '#e4e7ec',
  axis: '#667085',
  surface: '#ffffff',
  border: '#e4e7ec',
  series: ['#465fff', '#3641f5', '#7592ff', '#9cb9ff', '#262e89'],
  duo: { returning: '#3641f5', new: '#9cb9ff' },
};

const DARK: Omit<ChartTheme, 'isDark'> = {
  grid: '#1d2939',
  axis: '#98a2b3',
  surface: '#101828',
  border: '#1d2939',
  series: ['#7592ff', '#465fff', '#9cb9ff', '#c2d6ff', '#dde9ff'],
  duo: { returning: '#7592ff', new: '#c2d6ff' },
};

export const useChartTheme = (): ChartTheme => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  return { isDark, ...(isDark ? DARK : LIGHT) };
};
